// skrývání toolbaru při scrollu
function toolbarHideOnScroll() {
  let scrollValue = parseInt($('.toolbar').outerHeight());
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= scrollValue) {
      $('.toolbar').slideUp('fast');
    }
  });
}
